import { clear, createStore, del, get, keys, set, type UseStore } from "idb-keyval";
import type { PersistedClient, Persister } from "@tanstack/react-query-persist-client";

let store: UseStore | undefined;
// Created lazily: the module also loads during SSR, where there is no IndexedDB.
const getStore = () => (store ??= createStore("pylo-admin-panel", "query-cache"));

export const createSessionPersister = (customerId: string, userId: string): Persister => {
  const key = `${customerId}:${userId}`;
  let lastWrittenSignature = "";

  return {
    // Called on every cache event; only write when a persisted query actually changed.
    persistClient: async (client) => {
      const signature = client.clientState.queries
        .map((query) => `${query.queryHash}@${query.state.dataUpdatedAt}`)
        .join();
      if (signature === lastWrittenSignature) return;
      lastWrittenSignature = signature;
      await set(key, client, getStore());
    },
    restoreClient: async () => {
      // Only the signed-in user's cache may stay on this device.
      const otherKeys = (await keys(getStore())).filter((storedKey) => storedKey !== key);
      await Promise.all(otherKeys.map((storedKey) => del(storedKey, getStore())));
      return get<PersistedClient>(key, getStore());
    },
    removeClient: () => del(key, getStore()),
  };
};

export const clearPersistedQueries = () => clear(getStore());
